// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3931ff79","239":"ac130613","453":"bc4247e0","455":"89af6bd4"}[chunkId] + ".chunk.js";
};